import React, { Component } from 'react'
import styled from 'styled-components'

import { withRouter } from 'react-router'

import NavArrow from '../visuals/NavArrow.js'

const NavControls = styled.div`
  position: relative;
  margin: 0 16px;
  padding: 16px 0;
  width: 60px;
  height: 56px;
  box-sizing: border-box;

  float: left;

  & > * {

  }
`

const Wrap = styled.div`

  display: flex;
  justify-content: space-between;
  align-items: center;

`

class Navigation extends Component {

  goBack = () => {
    this.props.history.goBack()
  }

  goForward = () => {
    this.props.history.goForward()
  }

  render () {
    return (
      <NavControls>
        <Wrap>
          <NavArrow direction='previous' onClick={this.goBack} width='13' height='24' />
          <NavArrow direction='next' onClick={this.goForward} width='13' height='24' />
        </Wrap>
      </NavControls>
    )
  }
}

Navigation = withRouter(Navigation)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Topbar/Nav.js